import { ReactNode } from "react";
import { Navigate, Outlet, useParams } from "react-router";
import { useGetInstitutionQuery } from "@lending/hooks/queries/useGetInstitutionQuery";

interface MembershipShareGuardProps {
  fallbackPath: string;
  children?: ReactNode;
}

/**
 * Guard for membership share routes.
 *
 * This guard checks if the membership share flow is required for the current application.
 * If not required (no membership share product configured), it redirects to the fallback path.
 */
function MembershipShareGuard({ fallbackPath, children }: MembershipShareGuardProps) {
  const { institution } = useGetInstitutionQuery();
  const { applicationUuid } = useParams<{ applicationUuid: string }>();

  const isMembershipShareRequired = !!institution.membership_share_product_for_lending;
  const resolvedFallbackPath = applicationUuid
    ? fallbackPath.replace(":applicationUuid", applicationUuid)
    : fallbackPath;

  if (!isMembershipShareRequired) {
    return <Navigate to={resolvedFallbackPath} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
}

export { MembershipShareGuard };
